import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const SingaporeLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'SG',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Singapore',
  SHORT_NAME: 'SG',

  DISPLAY_NAME: 'Singapore (English)',
  DISPLAY_COUNTRY: 'Singapore',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 1.3521,
    INITIAL_LONGITUDE: 103.8198,
    INITIAL_ZOOM: 10,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/sg/en/',

  MAP_URL: 'https://www.uniqlo.com/sg/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL:
    'https://faq-sg.uniqlo.com/pkb_Home_UQ_SG?id=kA32t0000004C9X&l=en_US&c=category_uq_sg_my%3AUQSG_C6&fs=Search&pn=1',
  PRIVACY_POLICY_URL:
    'https://faq-sg.uniqlo.com/pkb_Home_UQ_SG?id=kA37F000000YMpt&l=en_US&c=category_uq_sg_my%3AUQSG_C6_3&fs=Search&pn=1',
  CONTACT_US_URL: 'https://faq-sg.uniqlo.com/',

  POSTCODE_FORMAT: /[0-9]{6}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SingaporeLocale
